export const MULTILANGUAGEGQLSCHEMA = `
En
Ar
Fr
`;
